module.exports = __webpack_public_path__ + "static/media/travel.b4ee3545.jpg";